import { render, staticRenderFns } from "./BackupDB.vue?vue&type=template&id=3e2dbcf2&scoped=true&"
import script from "./BackupDB.vue?vue&type=script&lang=js&"
export * from "./BackupDB.vue?vue&type=script&lang=js&"
import style0 from "./BackupDB.vue?vue&type=style&index=0&id=3e2dbcf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2dbcf2",
  null
  
)

export default component.exports